import '@babel/polyfill';

import '../resources/sitewide';
import '../resources/base';

import '../resources/components/site-container';
import '../resources/components/container';

import '../resources/components/box';
import '../resources/components/button';
import '../resources/components/button-row';
import '../resources/components/card';
import '../resources/components/form/form';
import '../resources/components/order-form/order-form.scss';
import '../resources/components/status-messages/status-messages.scss';
import '../resources/components/table/table.scss';
import '../resources/components/task-bar/task-bar.scss';

import '../resources/components/rich-text';

import '../resources/screens/homepage';
import '../resources/screens/user/user';
